import { type FC, type PropsWithChildren, useContext } from 'react';
import cn from 'classnames';

import { TabsContext } from './context';

interface TabProps extends PropsWithChildren {
  tabId: string;
  className?: string;
  alwaysStayInDom?: boolean;
}

const Tab: FC<TabProps> = ({ className, children, tabId, alwaysStayInDom }) => {
  const { activeTabId } = useContext(TabsContext);

  if (alwaysStayInDom) {
    return (
      <div
        className={cn(
          'w-full',
          className,
          tabId !== activeTabId &&
            'absolute opacity-0 -z-[1] pointer-events-none',
        )}
      >
        {children}
      </div>
    );
  }

  return (
    tabId === activeTabId && (
      <div className={cn('w-full', className)}>{children}</div>
    )
  );
};

export { Tab };
